import cn from 'classnames'
import Image from 'next/image'
import { FunctionComponent } from 'react'
import { HeaderTag } from '@/components/HeaderTag'
import moduleStyles from '@/modules/AboutPage/AboutPage.module.scss'
import ImageCompanyValues from '../../resources/companyValues.webp'
import styles from './CompanyValues.module.scss'

type CompanyValuesProps = {
  className?: string
  withoutImage?: boolean
}
export const CompanyValues: FunctionComponent<CompanyValuesProps> = ({
  className,
  withoutImage = false,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.headerTag}>
        <HeaderTag icon="gem" title="Ценности компании" />
      </div>
      <h2 className={cn(moduleStyles.title, styles.title)}>
        Безупречное качество — <br />
        наш абсолютный приоритет
      </h2>
      <div className={styles.description}>
        <p>Не&nbsp;боимся брать ответственность на&nbsp;себя</p>
        <p>и&nbsp;помогаем нашим клиентам</p>
      </div>
      {!withoutImage ? (
        <div className={styles.imageWrap}>
          <Image
            src={ImageCompanyValues}
            alt=""
            width={610}
            height={610}
            className={styles.image}
            sizes="(max-width: 767px) 319px, (max-widht: 1023px) 458px, 610px"
          />
        </div>
      ) : null}
    </div>
  )
}
